import React from "react";
import { formatIdDateTime } from "@/lib/format";

// Display-only panel: shows the audit trail of Product / Plant / Distrik
// swaps performed on an active SPB. Rendered only when the SPB has at
// least one entry in `master_overrides`.
export default function MasterOverridesPanel({ overrides }) {
  if (!overrides?.length) return null;
  return (
    <div className="border border-blue-500/40 bg-blue-50/30 mb-8" data-testid="master-overrides-panel">
      <div className="p-4 border-b border-blue-500/30 flex items-center gap-2 bg-blue-100/40">
        <span className="text-blue-700 font-bold uppercase text-xs tracking-widest">↻ Riwayat Ganti Master</span>
        <span className="text-xs text-blue-800 font-mono">({overrides.length}×)</span>
      </div>
      <div className="divide-y divide-blue-500/20">
        {overrides.map((ov, i) => {
          const nameKey = {
            produk: "produk_nama",
            plant: "plant",
            distrik: "distrik_nama",
          }[ov.field] || Object.keys(ov.new || {})[0];
          const oldLabel = ov.old?.[nameKey] || "-";
          const newLabel = ov.new?.[nameKey] || "-";
          const fieldLabel = ov.field ? ov.field.charAt(0).toUpperCase() + ov.field.slice(1) : "?";
          return (
            <div
              key={`${ov.at || i}-${ov.field}-${newLabel}`}
              className="p-4 grid grid-cols-1 md:grid-cols-[auto_1fr] gap-x-6 gap-y-1 text-sm"
              data-testid={`master-override-${i}`}
            >
              <div className="font-mono text-blue-800">
                <span className="text-[10px] uppercase tracking-widest border border-blue-500/40 px-1.5 py-0.5 mr-2 font-bold">{fieldLabel}</span>
                <span className="line-through opacity-60">{oldLabel}</span>
                <span className="mx-2">→</span>
                <span className="font-bold">{newLabel}</span>
              </div>
              <div className="text-xs text-muted-foreground">
                <span className="font-mono">{formatIdDateTime(ov.at)}</span>
                {ov.at_status && (
                  <span className="ml-2 uppercase text-[10px] tracking-wider border border-blue-500/40 px-1.5 py-0.5">{ov.at_status}</span>
                )}
              </div>
              {ov.reason && (
                <>
                  <div className="col-span-full md:col-span-1"></div>
                  <div>
                    <span className="text-muted-foreground">Alasan: </span>
                    <span className="italic">"{ov.reason}"</span>
                  </div>
                </>
              )}
              <div className="col-span-full md:col-span-1"></div>
              <div className="text-xs text-muted-foreground">
                Oleh <span className="font-semibold">{ov.by_name || ov.by}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
